import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_customer_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Add/Update Verifications", -1)
const _hoisted_6 = {
  id: "kt_modal_id_verification_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "First Name", -1)
const _hoisted_11 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Last Name", -1)
const _hoisted_13 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Country", -1)
const _hoisted_15 = {
  key: 0,
  class: "d-flex flex-column mb-7 fv-row"
}
const _hoisted_16 = {
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_17 = { class: "indicator-label" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_19 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_Notice = _resolveComponent("Notice")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: _ctx.$modals.AML_VERIFICATION_FORM_MODAL,
    ref: "amlVerificationModalRef",
    tabindex: "-1",
    "aria-hidden": "true",
    backdrop: "static",
    keyboard: "false"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_form, {
            onSubmit: _withModifiers($setup.handleSaveData, ["prevent"]),
            model: $setup.data,
            rules: $setup.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_el_form_item, { prop: "first_name" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: $setup.data.first_name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.first_name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_el_form_item, { prop: "last_name" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: $setup.data.last_name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.last_name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_form_item, { prop: "country" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_autocomplete, {
                      class: "inline-input w-100",
                      modelValue: $setup.data.country,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.country) = $event)),
                      "fetch-suggestions": $setup.searchCountries,
                      placeholder: "Search a country"
                    }, {
                      default: _withCtx(({ item }) => [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "fetch-suggestions"])
                  ]),
                  _: 1
                })
              ]),
              ($props.isGhanaCard)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    ($props.incpPrice)
                      ? (_openBlock(), _createBlock(_component_Notice, {
                          key: 0,
                          classes: "rounded-3",
                          color: "warning",
                          title: "NOTE!",
                          body: `Including pictures will cost an additional ${_ctx.$filters.formatCurrency(
                  $props.incpPrice
                )}`,
                          icon: "media/icons/duotune/general/gen044.svg"
                        }, null, 8, ["body"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", _hoisted_19, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _hoisted_20
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "model", "rules"])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}